import { render, staticRenderFns } from "./LimitTypeSelector.vue?vue&type=template&id=1911602c"
import script from "./LimitTypeSelector.vue?vue&type=script&lang=js"
export * from "./LimitTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports